import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { catchError, from, map, mergeMap, Observable, tap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { MsalService } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  username!: any;

  constructor(private router: Router,
    private loaderService:NgxUiLoaderService, 
    private authService: MsalService,
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      if (this.isAuthRequest(request)) {
        return next.handle(request);
      }
      return from(this.authService.acquireTokenSilent({
        scopes: [`${environment.domain}/.default`]
      })).pipe(
        mergeMap((token: any) => {
          const lang = localStorage.getItem('language') || 'en';
          const authReq = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token.accessToken}`,
              Accept: 'application/json',
              'OData-MaxVersion': '4.0',
              'OData-Version': '4.0',
              'Content-Type': 'application/json',
              language: lang
            }
          });
          return next.handle(authReq);
        }),
        catchError((error: any) => {  
          console.log(error);
          
        //   // if (error.errorCode === "no_account_error") {
        //     this.loaderService.stopAll();
        //     localStorage.clear()
        //     this.router.navigate(['/login'])
        //   // }
          return throwError(() => new Error())
        })
      );
    }

  private isAuthRequest(req: HttpRequest<any>): boolean {
    return req.url.includes('login') || req.url.includes('token') || req.url.includes('i18n') ;
  }

}
